import React from "react";
import { useNavigate } from "react-router-dom";
import CustomTable from "../../components/CustomTable";
import { getUsers } from "../../../store/actions/UserActions";
import CountIcon from "./../../../images/CountIcon.svg";
import { useSelector } from "react-redux";

const Users = () => {
  const navigate = useNavigate();
  const { auth } = useSelector((state) => state.auth);

  const handleRowClick = (_id, row) => {
    if (!row?._id || row._id == auth?.user?.userId) return;
    navigate("/users/edit", { state: row });
  };

  const ROLE_VALUE_TO_LABEL = {
    core_team: "Core Team",
    mentors: "Mentors",
    executive_team: "Executive Team",
    volunteers: "Volunteers",
  };
  const { stats } = useSelector((state) => state['users']);
  const columns = [
    {
      label: "#",
      render: (row, index, currentPage = 1, pageSize = 10) => (
        <span>{(currentPage - 1) * pageSize + index + 1}</span>
      ),
    },
    {
      label: "Name",
      render: (row) => (
        //   <span>{`${row.firstname} ${row.lastname}`}</span>
        <span>
          {row?.name
            ? row.name
            : `${row?.firstname ?? ""} ${row?.lastname ?? ""}`.trim()}
        </span>
      ),
    },
    {
      label: "Mobile",
      render: (row) => (
        //  <span>{`${row.country_code}${row.mobile}`}</span>,
        <span>
          {row?.country_code && row?.mobile
            ? `${row.country_code}${row.mobile}`
            : "-"}
        </span>
      ),
    },
    { label: "Email", key: "email" },
    {
      label: "Organisation",
      render: (row) => <span>{`${row?.organisation ?? "-"}`}</span>,
    },
    {
      label: "Role",
      render: (row) => (
        <span>{row?.role?.title || "-"}</span>
      ),
    },
  ];

  return (
    <div className="container-mxw">
      <div className="d-flex align-items-center mb-4 gap-4">
        {[
          {
            artForm: "Total Users",
            count: stats?.totalUsers || 0
          },
          {
            artForm: "Core Team",
            count: stats?.coreTeam || 0
          },
          {
            artForm: "Mentors",
            count: stats?.mentors || 0
          },
          {
            artForm: "Executive Team",
            count: stats?.executiveTeam || 0
          },
          {
            artForm: "Volunteers",
            count: stats?.volunteers || 0
          }
        ]
        .sort((a, b) => b.count - a.count) // Sort in descending order by count
        .map((item, index) => (
          <div
            key={index}
            className="d-flex align-items-center gap-3 count-box w-100"
          >
            <div className="align-self-start">
              <img src={CountIcon} />
            </div>
            <div>
              <h3>{item.artForm}</h3>
              <h4>{item.count}</h4>
            </div>
          </div>
        ))}
      </div>
      <CustomTable
        columns={columns}
        title="UNM Team Members"
        getHook={getUsers}
        store={"users"}
        deleteHook={"users"}
        addBtnTitle={"Add UNM Team Member"}
        search={true}
        onRowClick={handleRowClick}
      />
    </div>
  );
};

export default Users;
